"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var request_1 = require("../../../shared/request");
var EReadyState;
(function (EReadyState) {
    EReadyState[EReadyState["HEADERS_RECEIVED"] = 2] = "HEADERS_RECEIVED";
    EReadyState[EReadyState["DONE"] = 4] = "DONE";
})(EReadyState || (EReadyState = {}));
var ResponseRecycler = /** @class */ (function () {
    function ResponseRecycler(_a) {
        var resolve = _a.resolve, reject = _a.reject, request = _a.request, uri = _a.uri, config = _a.config;
        this.resolve = resolve;
        this.reject = reject;
        this.request = request;
        this.uri = uri;
        this.config = config;
    }
    ResponseRecycler.prototype.recycle = function (readyState) {
        if (readyState === EReadyState.HEADERS_RECEIVED) {
            this.assertZeroStatus();
            this.responseHeaders = this.parseResponseHeaders();
        }
        else if (readyState === EReadyState.DONE) {
            this.onDone();
        }
    };
    ResponseRecycler.prototype.assertZeroStatus = function () {
        if (this.request.status === 0) {
            this.reject(new request_1.ResponseNetworkError("Response from " + this.uri + " have invalid status code " + this.request.status));
        }
    };
    ResponseRecycler.prototype.parseResponseHeaders = function () {
        var str = this.request.getAllResponseHeaders();
        if (str.length === 0) {
            return [];
        }
        var toArray = ramda_1.split('\r\n');
        var withoutEmpty = ramda_1.filter(function (header) { return header.trim().length > 0; });
        var nameWithValue = ramda_1.map(function (header) {
            var index = header.indexOf(':');
            return [
                header
                    .slice(0, index)
                    .trim()
                    .toLowerCase(),
                header.slice(index + 1).trim(),
            ];
        });
        return ramda_1.pipe(toArray, withoutEmpty, nameWithValue)(str);
    };
    ResponseRecycler.prototype.onDone = function () {
        var _a = this, config = _a.config, uri = _a.uri, responseHeaders = _a.responseHeaders;
        var _b = this.request, status = _b.status, responseText = _b.responseText;
        this.resolve({
            /*TODO
             *  после связки с остальными частями посмотреть, нужно ли отдельно
             *  передавать body, headers, method из конфига
             * */
            requestBody: config.body || '',
            requestConfig: config,
            requestHeaders: config.headers || [],
            requestMethod: config.method || 'GET',
            requestURI: uri,
            responseBody: responseText,
            responseHeaders: responseHeaders,
            responseStatusCode: status,
        });
    };
    return ResponseRecycler;
}());
exports.ResponseRecycler = ResponseRecycler;
//# sourceMappingURL=responseRecycler.js.map